import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import BaseVariant from './BaseVariant';

const style = theme => ({
	root: {

	},
	input: {
		width: theme.components.input.criteria.width,
	}
})

function SmallerVariant({
	classes,
	index,
	formikProps,
	isLast,
	disabled
}) {

	return (
		<BaseVariant
			index={index}
			formikProps={formikProps}
			disableMin
			isLast={isLast}
			disabled={disabled}
		/>
	)
}

SmallerVariant.propTypes = {
	classes: PropTypes.any,
}

SmallerVariant.defaultProps = {
}

export default withStyles(style)(SmallerVariant);